<script lang="ts">
	import Svg from '$lib/svg/svg.svelte';
	import type { Icon } from '$lib/types/icons';
	import { fade } from 'svelte/transition';

	interface Props {
		color?: string;
		className?: string;
		icon?: Icon;
		iconColor?: string;
		iconCenter?: boolean;
		noTransition?: boolean;
		children?: import('svelte').Snippet;
	}

	let {
		color = 'info',
		className = '',
		icon = 'bubble',
		iconColor = '',
		iconCenter = false,
		noTransition = false,
		children
	}: Props = $props();

	let cssClass =
		$derived('text-' +
		color +
		'-on bg-' +
		color +
		' dark:text-' +
		color +
		'-dark-on dark:bg-' +
		color +
		'-dark');
</script>

<div
	class="transition-all rounded-md {cssClass} sm:p-5 p-4 flex gap-3 {iconCenter
		? 'items-center'
		: 'items-start'} {className}"
	in:fade={{ duration: noTransition ? 0 : 200 }}
	out:fade={{ duration: noTransition ? 0 : 200 }}
>
	{#if icon}
		<div class="text-4xl {iconColor} {iconCenter ? 'h-full flex items-center' : ''}">
			<Svg src={icon} className="sm:w-10 w-8 flex-none" />
		</div>
	{/if}
	<div class="w-full">
		{@render children?.()}
	</div>
</div>
